import { render, staticRenderFns } from "./InmuebleItem.vue?vue&type=template&id=ecd78dfa&scoped=true&"
import script from "./InmuebleItem.vue?vue&type=script&lang=js&"
export * from "./InmuebleItem.vue?vue&type=script&lang=js&"
import style0 from "./InmuebleItem.vue?vue&type=style&index=0&id=ecd78dfa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd78dfa",
  null
  
)

export default component.exports